import { useEffect } from 'react';
import { chatApi } from 'api/chat';
import { ChatMessage } from 'types/Chat';
import { useLongPollingQuery } from './useLP';
import { useChatContext } from './ChatContextProvider';

type UseChatConversationSubscriberOptions = {
	interlocutorMembershipId: number | null;
	onMessage: (data: ChatMessage) => void;
};

export const useChatConversationSubscriber = ({
	interlocutorMembershipId,
	onMessage,
}: UseChatConversationSubscriberOptions) => {
	const { currentProgramMembershipId } = useChatContext();

	const { cancel } = useLongPollingQuery(
		['sub-chat-message', { programMembership: Number(currentProgramMembershipId), interlocutorMembershipId }],
		({ signal }) =>
			chatApi.subChatMessage({
				params: {
					programMembershipId: Number(currentProgramMembershipId),
					interlocutorMembershipId: Number(interlocutorMembershipId),
					// bump: pageParam || 1,
				},
				signal,
			}),
		{
			enabled: Boolean(interlocutorMembershipId),
			onMessage,
		}
	);

	useEffect(() => {
		return () => {
			cancel();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [interlocutorMembershipId]);

	return null;
};
